import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import { block } from '../utils';
import DefaultMediaUploadModalContents from './DefaultMediaUploadModalContents';

export interface DefaultMediaUploadModalProps {}

const DefaultMediaUploadModal: React.FC<DefaultMediaUploadModalProps> = () => {
  return (
    <ConnectedModal name="MediaUpload" className={block('container')}>
      <DefaultMediaUploadModalContents />
    </ConnectedModal>
  );
};

export default DefaultMediaUploadModal;
